import { DocsHeading } from "../../../../src/components/DocsHeading";
import * as React from 'react';
export default {
  DocsHeading,
  React
};